import { theme } from 'antd';
import { ThemeConfigType } from './typing';

const colorBgContainer = '#22272e';
const colorBgLayout = '#1c2128';

const themeId = 'dark-dimmed';

export const darkDimmedTheme: ThemeConfigType = {
  id: themeId,
  type: 'dark',
  name: `themes.${themeId}`,
  previewImage: 'https://github.githubassets.com/assets/dark_dimmed_preview-82b04acf17cc.svg',
  previewImageDisc: 'https://github.githubassets.com/assets/dark_dimmed_disc-ee3bad70351b.svg',
  theme: {
    algorithm: [theme.darkAlgorithm],
    token: {
      blue: '#0366d6',
      purple: '#6f42c1',
      cyan: '#17a2b8',
      green: '#28a745',
      magenta: '#d63384',
      pink: '#e83e8c',
      red: '#e74c3c',
      orange: '#fd7e14',
      yellow: '#ffc107',
      volcano: '#d73a49',
      geekblue: '#6f42c1',
      gold: '#ffcc00',
      lime: '#b8e986',
      colorPrimary: '#0366d6',
      colorSuccess: '#28a745',
      colorWarning: '#ffc107',
      colorError: '#e74c3c',
      colorInfo: '#17a2b8',
      colorLink: '#0366d6',
      colorTextBase: '#c9d1d9',
      colorBgBase: '#0d1117',
      lineWidth: 1,
      lineType: 'solid',
      borderRadius: 6,
      colorText: 'rgba(201, 209, 217, 0.85)',
      colorTextSecondary: 'rgba(201, 209, 217, 0.75)',
      colorTextTertiary: 'rgba(201, 209, 217, 0.65)',
      colorTextQuaternary: 'rgba(201, 209, 217, 0.55)',
      colorFill: 'rgba(201, 209, 217, 0.1)',
      colorFillSecondary: 'rgba(201, 209, 217, 0.2)',
      colorFillTertiary: 'rgba(201, 209, 217, 0.3)',
      colorFillQuaternary: 'rgba(201, 209, 217, 0.4)',
      colorBgLayout: colorBgLayout,
      colorBgContainer: colorBgContainer,
      colorBgElevated: '#2d333b',
      colorBgSpotlight: 'rgba(32, 35, 39, 0.85)',
      colorBgBlur: 'transparent',
      colorBorder: '#444c56',
      colorBorderSecondary: '#373e47',
      // colorPrimaryBg: '#1c2128',
      // colorPrimaryBgHover: '#2d333b',
      // colorPrimaryBorder: '#444c56',
      // colorPrimaryBorderHover: '#57606a',
      // colorPrimaryHover: '#0366d6',
      // colorPrimaryActive: '#0056b3',
      // colorPrimaryTextHover: '#ffffff',
      // colorPrimaryText: '#c9d1d9',
      // colorPrimaryTextActive: '#ffffff',
      colorSuccessBg: '#1c2128',
      colorSuccessBgHover: '#2d333b',
      colorSuccessBorder: '#444c56',
      colorSuccessBorderHover: '#57606a',
      colorSuccessHover: '#28a745',
      colorSuccessActive: '#218838',
      colorSuccessTextHover: '#ffffff',
      colorSuccessText: '#c9d1d9',
      colorSuccessTextActive: '#ffffff',
      colorErrorBg: '#1c2128',
      colorErrorBgHover: '#2d333b',
      colorErrorBgActive: '#3e2c29',
      colorErrorBorder: '#444c56',
      colorErrorBorderHover: '#57606a',
      colorErrorHover: '#e74c3c',
      colorErrorActive: '#c0392b',
      colorErrorTextHover: '#ffffff',
      colorErrorText: '#c9d1d9',
      colorErrorTextActive: '#ffffff',
      colorWarningBg: '#1c2128',
      colorWarningBgHover: '#2d333b',
      colorWarningBorder: '#444c56',
      colorWarningBorderHover: '#57606a',
      colorWarningHover: '#ffc107',
      colorWarningActive: '#e0a800',
      colorWarningTextHover: '#ffffff',
      colorWarningText: '#c9d1d9',
      colorWarningTextActive: '#ffffff',
      colorInfoBg: '#1c2128',
      colorInfoBgHover: '#2d333b',
      colorInfoBorder: '#444c56',
      colorInfoBorderHover: '#57606a',
      colorInfoHover: '#17a2b8',
      colorInfoActive: '#138496',
      colorInfoTextHover: '#ffffff',
      colorInfoText: '#c9d1d9',
      colorInfoTextActive: '#ffffff',
      colorLinkHover: '#ffffff',
      colorLinkActive: '#0366d6',
      colorBgMask: 'rgba(0, 0, 0, 0.65)',
      colorWhite: '#ffffff',
      lineWidthBold: 2,
      colorFillContent: 'rgba(201, 209, 217, 0.08)',
      colorFillContentHover: 'rgba(201, 209, 217, 0.16)',
      colorFillAlter: 'rgba(201, 209, 217, 0.04)',
      colorBgContainerDisabled: 'rgba(32, 35, 39, 0.6)',
      colorBorderBg: '#1c2128',
      colorSplit: 'rgba(201, 209, 217, 0.12)',
      colorTextPlaceholder: 'rgba(201, 209, 217, 0.4)',
      colorTextDisabled: 'rgba(201, 209, 217, 0.3)',
      colorTextHeading: 'rgba(201, 209, 217, 0.9)',
      colorTextLabel: 'rgba(201, 209, 217, 0.85)',
      colorTextDescription: 'rgba(201, 209, 217, 0.75)',
      colorTextLightSolid: '#ffffff',
      colorHighlight: '#0366d6',
      colorBgTextHover: 'rgba(201, 209, 217, 0.08)',
      colorBgTextActive: 'rgba(201, 209, 217, 0.16)',
      colorIcon: 'rgba(201, 209, 217, 0.65)',
      colorIconHover: 'rgba(201, 209, 217, 0.85)',
      colorErrorOutline: 'rgba(231, 76, 60, 0.8)',
      colorWarningOutline: 'rgba(255, 193, 7, 0.8)',
      controlItemBgHover: 'rgba(201, 209, 217, 0.08)',
      controlItemBgActive: '#0366d6',
      controlItemBgActiveHover: '#0056b3',
      controlItemBgActiveDisabled: 'rgba(201, 209, 217, 0.3)',
      controlTmpOutline: 'rgba(32, 35, 39, 0.8)',
      controlOutline: 'rgba(32, 35, 39, 0.8)',
      linkDecoration: 'none',
      linkHoverDecoration: 'underline',
      linkFocusDecoration: 'underline',
      boxShadow:
        '\n      0 6px 16px 0 rgba(0, 0, 0, 0.8),\n      0 3px 6px -4px rgba(0, 0, 0, 0.12),\n      0 9px 28px 8px rgba(0, 0, 0, 0.05)\n    ',
      boxShadowSecondary:
        '\n      0 6px 16px 0 rgba(0, 0, 0, 0.8),\n      0 3px 6px -4px rgba(0, 0, 0, 0.12),\n      0 9px 28px 8px rgba(0, 0, 0, 0.05)\n    ',
      boxShadowTertiary:
        '\n      0 1px 2px 0 rgba(0, 0, 0, 0.3),\n      0 1px 6px -1px rgba(0, 0, 0, 0.12),\n      0 2px 4px 0 rgba(0, 0, 0, 0.02)\n    ',
    },
  },
  layout: {
    hashId: themeId,
    colorPrimary: '#0366d6',
    colorTextAppListIcon: 'rgba(201, 209, 217, 0.75)',
    colorBgAppListIconHover: 'rgba(201, 209, 217, 0.08)',
    colorTextAppListIconHover: 'rgba(201, 209, 217, 0.85)',
    bgLayout: `linear-gradient(${colorBgContainer}, ${colorBgLayout} 28%)`,
    sider: {
      paddingInlineLayoutMenu: 8,
      paddingBlockLayoutMenu: 0,
      colorBgCollapsedButton: '#22272e',
      colorTextCollapsedButtonHover: 'rgba(201, 209, 217, 0.85)',
      colorTextCollapsedButton: 'rgba(201, 209, 217, 0.65)',
      colorMenuBackground: 'transparent',
      colorMenuItemDivider: 'rgba(201, 209, 217, 0.12)',
      colorBgMenuItemHover: 'rgba(201, 209, 217, 0.08)',
      colorBgMenuItemSelected: 'rgba(201, 209, 217, 0.16)',
      colorTextMenuItemHover: 'rgba(201, 209, 217, 0.85)',
      colorTextMenuSelected: 'rgba(201, 209, 217, 0.85)',
      colorTextMenuActive: 'rgba(201, 209, 217, 0.9)',
      colorTextMenu: 'rgba(201, 209, 217, 0.75)',
      colorTextMenuSecondary: 'rgba(201, 209, 217, 0.65)',
      colorTextMenuTitle: 'rgba(201, 209, 217, 0.85)',
      colorTextSubMenuSelected: 'rgba(201, 209, 217, 0.85)',
      colorBgMenuItemActive: 'rgba(201, 209, 217, 0.16)',
      colorBgMenuItemCollapsedElevated: 'transparent',
    },
    header: {
      colorBgHeader: 'rgba(32, 35, 39, 0.85)',
      colorBgScrollHeader: 'rgba(32, 35, 39, 0.65)',
      colorHeaderTitle: 'rgba(201, 209, 217, 0.85)',
      colorBgMenuItemHover: 'rgba(201, 209, 217, 0.08)',
      colorBgMenuItemSelected: 'transparent',
      colorTextMenuSelected: 'rgba(201, 209, 217, 0.85)',
      colorBgRightActionsItemHover: 'rgba(201, 209, 217, 0.08)',
      colorTextRightActionsItem: 'rgba(201, 209, 217, 0.75)',
      heightLayoutHeader: 56,
      colorTextMenu: 'rgba(201, 209, 217, 0.75)',
      colorTextMenuSecondary: 'rgba(201, 209, 217, 0.65)',
      colorTextMenuActive: 'rgba(201, 209, 217, 0.9)',
      colorBgMenuElevated: 'rgba(32, 35, 39, 0.85)',
    },
    pageContainer: {
      colorBgPageContainer: 'transparent',
      paddingInlinePageContainerContent: 40,
      paddingBlockPageContainerContent: 32,
      colorBgPageContainerFixed: '#1c2128',
    },
  },
};
